import React, { useState, useMemo, Key } from 'react';
import { Dropdown, Checkbox, Input, CheckboxChangeEvent } from 'antd';
import { Columns } from 'types';
import { ButtonCommon } from '..';
import { CaretDown } from '@phosphor-icons/react';

interface ColumnSelectorProps {
  allColumns: Columns[];
  selectedColumns: (Key | undefined)[] | undefined;
  onChange: (selected: string[]) => void;
  columnDisable? : string
  defaultColumnChecked?: string;

}


export const ColumnSelector: React.FC<ColumnSelectorProps> = ({
  allColumns,
  selectedColumns,
  onChange,
  defaultColumnChecked = 'code',
  columnDisable
}) => {
  const [searchText, setSearchText] = useState<string>('');

  const filteredColumns = useMemo<Columns[]>(() => {
    const trimmedSearchText = searchText.trim().toLowerCase();
    return allColumns.filter((col) => col.title.toLowerCase().includes(trimmedSearchText));
  }, [allColumns, searchText]);
  const codeColumnExists = useMemo(() => {
    return allColumns.some((col) => col.key === defaultColumnChecked);
  }, [allColumns]);

  const handleSelectAllChange = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      onChange(allColumns?.map((col) => col.key));
    } else {
      onChange(codeColumnExists ? [defaultColumnChecked] : []);
    }
  };

  const handleCheckboxGroupChange = (checkedValues: Array<string | number>) => {
    let newValues = checkedValues.map((v) => String(v));

    if (codeColumnExists && !newValues.includes(defaultColumnChecked)) {
      newValues = [defaultColumnChecked, ...newValues];
    }

    onChange(newValues);
  };

  const dropdownContent = (
    <div className='w-[224px] bg-[var(--secondColor)] rounded-[8px] flex flex-col column-selector'>
      <Input.Search
        placeholder='Tìm kiếm'
        allowClear
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      <Checkbox
        indeterminate={selectedColumns && selectedColumns.length > 0 && selectedColumns.length < allColumns.length}
        checked={selectedColumns && selectedColumns.length === allColumns.length}
        onChange={(e) => handleSelectAllChange(e)}
      >
        Tất cả
      </Checkbox>
      <Checkbox.Group
        value={selectedColumns?.map((col) => String(col))}
        onChange={handleCheckboxGroupChange}
        style={{ display: 'flex', flexDirection: 'column', gap: 6 }}
      >
        {filteredColumns.map((col) => {
          return(
            <Checkbox
              key={col.key}
              value={col.key}
              disabled={col.key === 'code' || col.key === columnDisable}
              checked={col.key === 'code' || selectedColumns?.includes(col.key) || false}
            >
              {col.title}
            </Checkbox>
          )

        })}
      </Checkbox.Group>
    </div>
  );

  return (
    <Dropdown overlay={dropdownContent} trigger={['click']} placement='bottomLeft'>
      <ButtonCommon icon={<CaretDown size={20} />} iconPosition='right' color='outline' size='xs' radius='rounded'>
        {`${(selectedColumns && selectedColumns.length) || 0} cột hiển thị`}
      </ButtonCommon>
    </Dropdown>
  );
};
